import { render } from "./TaxExempt.vue?vue&type=template&id=31c35faf"
import script from "../js/tax-exempt.js?vue&type=script&lang=js&external"
export * from "../js/tax-exempt.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__